import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';

class PrintService {
    static printURL = (url, name, viewport) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();

        return fetchAPI({
            token: token,
            url: `${config.PrintService}url`,
            method: 'POST',
            body: {
                url,
                name,
                viewport,
            },
        });
    };
    static printHTML = (html, name, viewport) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();

        return fetchAPI({
            token: token,
            url: `${config.PrintService}html`,
            method: 'POST',
            body: {
                html,
                name,
                viewport,
            },
        });
    };
}

export default PrintService;
